var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightWhiteOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3657 0.348263C12.8676 -0.129828 12.0764 -0.113675 11.5983 0.384342C11.0539 0.951441 11.25 1.75 11.635 2.15241C13.3817 3.83852 15.1269 5.58508 16.6231 7.5L1.25 7.5C0.559644 7.5 0 8.05965 0 8.75C0 9.44036 0.559644 10 1.25 10L16.6231 10C15.1254 11.9168 13.3813 13.6619 11.6343 15.3483C11.1363 15.8264 11.1202 16.6177 11.5983 17.1157C12.0764 17.6137 12.8682 17.6293 13.3662 17.1513C15.2719 15.3119 17.1684 13.4235 18.7699 11.3095C19.316 10.5886 20.0001 9.69934 20.0001 8.75C20.0001 7.80066 19.316 6.9114 18.7699 6.19049C17.1727 4.08232 15.2646 2.18102 13.3657 0.348263Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhiteOutline);
export default __webpack_public_path__ + "static/media/arrowRightWhiteOutline.af5147c79110e5f687ce05972fab4748.svg";
export { ForwardRef as ReactComponent };